module.exports = __webpack_public_path__ + "img/globe-corner.8e7c662f.svg";